import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ChartTableCellStyleConstantType,
    ChartTableDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    cell: {
        justifyContent: "center",
        flexShrink: 0,
        flexGrow: 1
    },
    firstCell: {
        alignItems: "flex-start",
        ...webStyle({
            insetInlineStart: 0,
            position: "sticky"
        })
    },
    row: {
        alignItems: "stretch",
        flexDirection: "row"
    },
    numberCell: {
        alignItems: "flex-end"
    },
    scroll: {
        width: "100%"
    },
    scrollContent: {
        flexGrow: 1
    },
    table: {
        flexGrow: 1
    }
});

export const getChartTableCellStyle = ({
    controlHeights,
    isFirstColumn,
    isLastColumn,
    shapeConfigs,
    isLastRow,
    isHeader,
    borders,
    colors,
    spaces
}: ChartTableCellStyleConstantType): ViewStyle => {
    const style: Mutable<ViewStyle> = {
        minWidth: isFirstColumn ? controlHeights.large * 3 : controlHeights.large * 2,
        height: isHeader ? controlHeights.small : controlHeights.medium,
        paddingHorizontal: spaces.spacingMd
    };

    if(isFirstColumn) {
        Object.assign(style, {
            backgroundColor: colors.content.container.raised,
            zIndex: shapeConfigs.layers.raised,
            paddingStart: 0
        });
    }

    if(isLastColumn) {
        style.paddingEnd = 0;
    }

    if(!isLastRow) {
        Object.assign(style, {
            borderBottomColor: colors.content.border.subtle,
            borderBottomWidth: borders.separator
        });
    }

    return style;
};

export const useStyles = ({
    spaces
}: ChartTableDynamicStyleType) => {
    const styles = {
        caption: {
            paddingBottom: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
